import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import SuccessModal from '../../../../features/components/Modals/SuccessModal'

import useIsInternalAdCreation from '../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

import { MODAL_TYPE } from '../../../../constants/other'

const UploadAdCreativeSuccessModal = ({ onModalClose, onGoToAdSet }) => {
  const { t } = useTranslation()

  // all users which are not rights_holder type, can create only quarantine (internal) ads
  const isInternalAdCreation = useIsInternalAdCreation()

  return (
    <SuccessModal
      successButtonText="Go to Ad Set"
      successButtonAction={onGoToAdSet}
      modalType={MODAL_TYPE.rightFacebookAdUploaded}
      onAfterClose={onModalClose}
      showCloseButton
    >
      <p>
        {t(
          isInternalAdCreation
            ? 'Your ad has been uploaded successfully and is pending review.'
            : 'Your ad has been uploaded successfully.'
        )}
      </p>
    </SuccessModal>
  )
}

UploadAdCreativeSuccessModal.propTypes = {
  onGoToAdSet: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired
}

export default UploadAdCreativeSuccessModal
